import '../styles/index.scss';
import { createApp } from 'vue';
import VueToast from 'vue-toast-notification';
import { setupI18n } from '@/i18n';

import App from './AppPassword.vue';

const i18n = setupI18n();
const app = createApp(App);
app.use(VueToast);

app.use(i18n);
app.mount('#app');
